export enum ProductType {
    Paid,
    Donation,
    Offline,
    Calculated
}